class Customization {
  // border
  borderColor = '#D9B244';
  borderWidth = 4;

  //corner
  cornerSize = 10;
  cornerColor = '#F2F3F4';
  cornerStrokeColor = '#000000';
  cornerStyle: 'circle' | 'rect' | undefined = 'circle';
  transparentCorners = false;

  getAllProperties() {
    return {
      borderColor: this.borderColor,
      borderScaleFactor: this.borderWidth,
      cornerSize: this.cornerSize,
      cornerColor: this.cornerColor,
      cornerStrokeColor: this.cornerStrokeColor,
      cornerStyle: this.cornerStyle,
      transparentCorners: this.transparentCorners,
    };
  }
}

const customization = new Customization();
export default customization;
